/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { IGeneralDetailsProps } from "../../../../../../shared";
import useCustomResources from "../../../../../../shared/hooks/useCustomResources/useCustomResources";
import { useStyles } from "../../../../styles";
import DetailsCard from "../DetailsCard";
import DetailsCardItemText from "../DetailsCardItemText";
import DetailsCardItemTitle from "../DetailsCardItemTitle";

const AnalysisProvidersGeneralDetails = ({
  detailsData
}: IGeneralDetailsProps) => {
  const { t } = useTranslation();
  const { paperCardItem } = useStyles();

  const { getConvertedStringToDate } = useCustomResources();

  return detailsData ? (
    <DetailsCard cardTitle={t("Details##general")} detailsData={detailsData}>
      <div css={css(paperCardItem)}>
        <DetailsCardItemTitle title={t("Details##company")} />
        <DetailsCardItemText textToRender={detailsData.company.name} />
      </div>

      <div css={css([paperCardItem])}>
        <DetailsCardItemTitle title={t("Table##provider")} />
        <DetailsCardItemText textToRender={detailsData.provider} />
      </div>

      <div css={css(paperCardItem)}>
        <DetailsCardItemTitle title={t("Table##created by")} />
        <DetailsCardItemText textToRender={detailsData.createdBy} />
      </div>

      <div css={css(paperCardItem)}>
        <DetailsCardItemTitle title={t("Table##created at")} />
        <DetailsCardItemText
          textToRender={getConvertedStringToDate(detailsData.createdAt)}
        />
      </div>

      <div css={css(paperCardItem)}>
        <DetailsCardItemTitle title={t("Table##last event")} />
        <DetailsCardItemText
          textToRender={getConvertedStringToDate(detailsData.lastEvent)}
        />
      </div>
    </DetailsCard>
  ) : (
    <></>
  );
};

export default AnalysisProvidersGeneralDetails;
